export default __webpack_public_path__ + "52675856343d08be24de228de9816d16.png";